import { render, staticRenderFns } from "./PayrollReportList.vue?vue&type=template&id=87f0f754&scoped=true&"
import script from "./PayrollReportList.vue?vue&type=script&lang=ts&"
export * from "./PayrollReportList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f0f754",
  null
  
)

export default component.exports